// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__42dk6","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2t31D"};